// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37907d52","453":"2e82c4dd","455":"dc2db6ff"}[chunkId] + ".chunk.js";
};